module.exports = __webpack_public_path__ + "static/media/User_Man_icon.d212cddd.svg";